import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateModifierResult = { modifier: '_modifier' };
var _bulkCreateModifiersRequest = { modifiers: '_modifier' };
var _bulkCreateModifiersResponse = { results: '_bulkCreateModifierResult' };
var _bulkDeleteModifiersRequest = {};
var _bulkDeleteModifiersResponse = {};
var _bulkUpdateModifierResult = { modifier: '_modifier' };
var _bulkUpdateModifiersRequest = { modifiers: '_maskedModifier' };
var _bulkUpdateModifiersResponse = { results: '_bulkUpdateModifierResult' };
var _cloneModifiersRequest = {};
var _cloneModifiersResponse = {};
var _countModifiersRequest = {};
var _countModifiersResponse = {};
var _createModifierRequest = { modifier: '_modifier' };
var _createModifierResponse = { modifier: '_modifier' };
var _deleteModifierRequest = {};
var _deleteModifierResponse = {};
var _externalReferenceInfo = { lastSyncDate: 'google.protobuf.Timestamp' };
var _getModifierRequest = {};
var _getModifierResponse = { modifier: '_modifier' };
var _listModifiersRequest = {};
var _listModifiersResponse = { modifiers: '_modifier' };
var _maskedModifier = {
    mask: 'google.protobuf.FieldMask',
    modifier: '_modifier',
};
var _modifier = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    externalReferenceInfo: '_externalReferenceInfo',
};
var _queryModifiersRequest = {};
var _queryModifiersResponse = { modifiers: '_modifier' };
var _updateModifierRequest = {
    mask: 'google.protobuf.FieldMask',
    modifier: '_modifier',
};
var _updateModifierResponse = { modifier: '_modifier' };
function resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers/delete',
                destPath: '/v1/bulk/modifiers/delete',
            },
            {
                srcPath: '/restaurants/menus/v1/modifiers/count',
                destPath: '/v1/modifiers/count',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers/create',
                destPath: '/v1/bulk/modifiers/create',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers/delete',
                destPath: '/v1/bulk/modifiers/delete',
            },
            {
                srcPath: '/restaurants/menus/v1/modifiers/count',
                destPath: '/v1/modifiers/count',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers/create',
                destPath: '/v1/bulk/modifiers/create',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-menus-item-modifier',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/item-modifiers',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers/create',
                destPath: '/v1/bulk/modifiers/create',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers/update',
                destPath: '/v1/bulk/modifiers/update',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers/delete',
                destPath: '/v1/bulk/modifiers/delete',
            },
            {
                srcPath: '/restaurants/menus/v1/modifiers/count',
                destPath: '/v1/modifiers/count',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/restaurants-menus-item-modifier',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Note:** The Item Modifiers API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates an item modifier.
 *
 * To create multiple item modifiers at once, use [Bulk Create Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/bulk-create-modifiers).
 */
export function createModifier(payload) {
    var _a = serializer(_createModifierRequest, { _externalReferenceInfo: _externalReferenceInfo, _modifier: _modifier }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createModifierResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _modifier: _modifier,
    }).fromJSON;
    function __createModifier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.CreateModifier',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/modifiers',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createModifier.fromReq = fromReq;
    __createModifier.__isAmbassador = true;
    return __createModifier;
}
/**
 * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves an item modifier by ID.
 */
export function getModifier(payload) {
    var _a = serializer(_getModifierRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getModifierResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _modifier: _modifier,
    }).fromJSON;
    function __getModifier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'GET',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.GetModifier',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/modifiers/{modifierId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getModifier.fromReq = fromReq;
    __getModifier.__isAmbassador = true;
    return __getModifier;
}
/**
 * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 500 item modifiers.
 */
export function listModifiers(payload) {
    var _a = serializer(_listModifiersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listModifiersResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _modifier: _modifier,
    }).fromJSON;
    function __listModifiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'GET',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.ListModifiers',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/modifiers',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listModifiers.fromReq = fromReq;
    __listModifiers.__isAmbassador = true;
    return __listModifiers;
}
/**
 * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates an item modifier.
 *
 * To update multiple item modifiers at once, use [Bulk Update Item Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/bulk-update-modifiers).
 *
 * Each time an item modifier is updated, its revision increments by 1. The existing revision must be included when updating an item modifier. This ensures you're working with the latest item modifier information, and it prevents unintended overwrites.
 */
export function updateModifier(payload) {
    var _a = serializer(_updateModifierRequest, { _externalReferenceInfo: _externalReferenceInfo, _modifier: _modifier }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateModifierResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _modifier: _modifier,
    }).fromJSON;
    function __updateModifier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'PATCH',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.UpdateModifier',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/modifiers/{modifier.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateModifier.fromReq = fromReq;
    __updateModifier.__isAmbassador = true;
    return __updateModifier;
}
/**
 * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates multiple item modifiers.
 */
export function bulkCreateModifiers(payload) {
    var _a = serializer(_bulkCreateModifiersRequest, { _externalReferenceInfo: _externalReferenceInfo, _modifier: _modifier }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateModifiersResponse, {
        _bulkCreateModifierResult: _bulkCreateModifierResult,
        _externalReferenceInfo: _externalReferenceInfo,
        _modifier: _modifier,
    }).fromJSON;
    function __bulkCreateModifiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.BulkCreateModifiers',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/bulk/modifiers/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateModifiers.fromReq = fromReq;
    __bulkCreateModifiers.__isAmbassador = true;
    return __bulkCreateModifiers;
}
/**
 * > **Note:** The Item modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates multiple item modifiers at once.
 * Each time an item modifier is updated, its revision increments by 1. The existing revision must be included when updating the item modifier. This ensures you're working with the latest item modifier information, and prevents unintended overwrites.
 */
export function bulkUpdateModifiers(payload) {
    var _a = serializer(_bulkUpdateModifiersRequest, { _externalReferenceInfo: _externalReferenceInfo, _maskedModifier: _maskedModifier, _modifier: _modifier }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateModifiersResponse, {
        _bulkUpdateModifierResult: _bulkUpdateModifierResult,
        _externalReferenceInfo: _externalReferenceInfo,
        _modifier: _modifier,
    }).fromJSON;
    function __bulkUpdateModifiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.BulkUpdateModifiers',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/bulk/modifiers/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateModifiers.fromReq = fromReq;
    __bulkUpdateModifiers.__isAmbassador = true;
    return __bulkUpdateModifiers;
}
/**
 * > **Note:** The Item modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 * Deletes an item modifier.
 */
export function deleteModifier(payload) {
    var _a = serializer(_deleteModifierRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteModifierResponse, {}).fromJSON;
    function __deleteModifier(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.DeleteModifier',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/modifiers/{modifierId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteModifier.fromReq = fromReq;
    __deleteModifier.__isAmbassador = true;
    return __deleteModifier;
}
/**
 * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of item modifiers given the provided paging, filtering, and sorting. Up to 500 item modifiers can be returned per request.
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifiers/supported-filters-and-sorting) article. To learn how to query menus, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 */
export function queryModifiers(payload) {
    var _a = serializer(_queryModifiersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryModifiersResponse, {
        _externalReferenceInfo: _externalReferenceInfo,
        _modifier: _modifier,
    }).fromJSON;
    function __queryModifiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.QueryModifiers',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/modifiers/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryModifiers.fromReq = fromReq;
    __queryModifiers.__isAmbassador = true;
    return __queryModifiers;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves the number of modifiers that match a specified filter.
 *
 * If a filter isn't passed in the request, the endpoint returns the count of all modifiers.
 */
export function countModifiers(payload) {
    var _a = serializer(_countModifiersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countModifiersResponse, {}).fromJSON;
    function __countModifiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.CountModifiers',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/modifiers/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countModifiers.fromReq = fromReq;
    __countModifiers.__isAmbassador = true;
    return __countModifiers;
}
/**
 * > **Note:** The Item Modifier API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes multiple item Modifiers at once.
 */
export function bulkDeleteModifiers(payload) {
    var _a = serializer(_bulkDeleteModifiersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteModifiersResponse, {}).fromJSON;
    function __bulkDeleteModifiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.BulkDeleteModifiers',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/bulk/modifiers/delete',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteModifiers.fromReq = fromReq;
    __bulkDeleteModifiers.__isAmbassador = true;
    return __bulkDeleteModifiers;
}
/** Clone item modifiers from a different metasite. */
export function cloneModifiers(payload) {
    var _a = serializer(_cloneModifiersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneModifiersResponse, {}).fromJSON;
    function __cloneModifiers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus_item_modifier.v1.ModifiersService.CloneModifiers',
            url: resolveWixRestaurantsMenusItemModifierV1ModifiersServiceUrl({
                protoPath: '/v1/modifiers/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneModifiers.fromReq = fromReq;
    __cloneModifiers.__isAmbassador = true;
    return __cloneModifiers;
}
//# sourceMappingURL=http.impl.js.map